export default __webpack_public_path__ + "images/assets/c68f18e672a60b99c5c48bcc31444424.svg";